module.exports = __webpack_public_path__ + "img/fill_gradient.c61b6134.svg";